import * as React from 'react';
import DeferredTab from './deferred_tab';
import { shallow, ShallowWrapper } from 'enzyme';

let wrapped: ShallowWrapper;

describe('Deferred Tab component', () => {
  beforeEach(() => {
    wrapped = shallow(<DeferredTab title='' url='' />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
